<template>
  <div class="fill-height">
    <div class="d-flex justify-center flex-column align-center fill-height">
      <v-img
        src="../assets/illustration/not-found.svg"
        max-width="280"
        max-height="280"
        contain
      ></v-img>
      <h2 class="text-center">Kamu sendirian dan nyasar (404)</h2>
      <p class="text-center">
        Aku masih disini menunggu kamu yang pergi meninggalkanku
      </p>
      <v-btn color="primary" :to="{ name: 'Home' }">Balikan yuk</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
};
</script>

<style scoped></style>
